import React, { Fragment } from 'react';
import { Box, CircularProgress } from '@mui/material';
import useFetchData from '../../shared/hooks/use-fetch-data';

import ItemsList from '../../items/components/ItemList';

const Items = () => {
  const { data, loading } = useFetchData({
    method: 'get',
    url: 'items'
  });

  return (
    <Fragment>
      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: 300 }}>
          <CircularProgress sx={{ color: '#0d9488' }} />
        </Box>
      )}
      {!loading && <ItemsList items={data} />}
    </Fragment>
  );
};

export default Items;
